export const personalInfo = {
  name: {
    first: "Vishal",
    last: "Panwar",
    full: "Vishal Panwar"
  },
  title: "Software Development Engineer | Gen AI Products · Backend",
  shortBio: "Shipping Gen AI products and AI applications with Go, Next.js, and GCP.",
  experienceYears: "2+",
  contact: {
    email: "vishalpanwar416@gmail.com",
    phone: "+91 7500988212",
    phoneFormatted: "+91 7500988212",
    phoneLink: "tel:+917500988212",
    whatsapp: "917500988212"
  },
  location: {
    city: "Hyderabad",
    country: "India",
    region: "IN",
    display: "Hyderabad · Remote OK"
  },
  availability: {
    status: "Open to Backend, Full Stack, SRE & Go roles",
    badge: "Available for work",
    badgeShort: "Open",
    timezone: "IST (UTC+5:30)",
    hours: "9:00 AM - 6:00 PM",
    workPreference: "Remote (India), US, or Gulf region",
    noticePeriod: "Immediate to 30 days",
    availableDays: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
    unavailableDays: ["Saturday", "Sunday"]
  },
  heroStats: {
    stack: ["Gen AI · Backend", "Go / Next.js / GCP", "300+ LeetCode"]
  },
  username: {
    github: "vishalpanwar416",
    leetcode: "vishalpanwar416",
    twitter: "vishalpanwar416",
    instagram: "vee.pyai"
  }
}
